type CreateJobFooterProps = {
    isEditMode: boolean
    isFormValid: boolean
    isCreatingJob: boolean
    onAction: () => void
}

export const CreateJobFooter = ({
    isEditMode,
    isFormValid,
    isCreatingJob,
    onAction,
}: CreateJobFooterProps) => (
    <div className="flex justify-end gap-4 mt-12 pb-10">
        <button
            onClick={onAction}
            disabled={!isFormValid || isCreatingJob}
            className="btn-cta px-12 py-3 font-medium rounded-md text-sm disabled:opacity-50 disabled:hover:bg-black"
        >
            {isEditMode ? "Update" : "Next"}
        </button>
    </div>
)
